// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';

// Styles
import './_hero-banner.scss';

// -------------------------------------
// Variables
// -------------------------------------
const THE_SECTION = document.querySelector('.homepage-hero');
const SCROLL_PAST_ELEMENT = document.querySelector('.js--homepage-content');

// Classes
const SCROLL_PAST_CLASS = 'hide-overlay'


// Function to check if header is scrolled past sign up bar
function isElementScrolledPast(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const offset = 200; // Adjust for 200px earlier

    return (rect.bottom < offset || rect.top > windowHeight - offset);
}

function isElementScrolledToTop(element) {
    const rect = element.getBoundingClientRect();
    return rect.top <= 0;
}

// Function to handle scroll events
function handleScroll(element) {
    if (isElementScrolledToTop(SCROLL_PAST_ELEMENT)) {
        element.classList.add(SCROLL_PAST_CLASS);
    } else {
        element.classList.remove(SCROLL_PAST_CLASS);
    }
}

// Attach the scroll event listener
window.addEventListener('scroll', function() {
    if( THE_SECTION !== null && SCROLL_PAST_ELEMENT !== null ) {
        handleScroll(THE_SECTION);
    }
});

// Initial check on page load
document.addEventListener("DOMContentLoaded", function() {
    if( THE_SECTION !== null && SCROLL_PAST_ELEMENT !== null ) {
        handleScroll(THE_SECTION);
    }
});